import { useCallback } from 'react'
import { useMutation } from 'react-query'
import messageCreateService from '../../services/api/message-create'
import useToasts from '../use-toasts'
import useMessagesCache from '../use-messages-cache'

const useMessageCreation = ({
    onCreated = () => {}
}) => {
    const { clear: clearCache } = useMessagesCache()
    const { success } = useToasts()
    const onCreateSuccess = useCallback(() => {
        success('Message sent!')
        clearCache()
        onCreated()
    }, [success, onCreated, clearCache])
    const [
        createMessage,
        { isLoading, error }
    ] = useMutation(messageCreateService, { onSuccess: onCreateSuccess })
    return {
        isError: Boolean(error),
        isCreating: isLoading,
        createMessage
    }
}

export default useMessageCreation